export const formatPhoneNumber = (phone: string) => {
	const digits = phone.replace(/\D/g, '');

	if (digits.length === 10) {
		return digits.replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3');
	}
	if (digits.length === 11) {
		return digits.replace(/(\d)(\d{3})(\d{3})(\d{4})/, '$1 $2 $3 $4');
	}
	return digits;
};
